import { BasicRequest } from "./basicRequest";

export class DeleteFilterDefinitionRequest extends BasicRequest{
    public filterDefinitionId! : number;
    public physicalDelete : boolean = false;
}